import { useUpdatePersonPrivateInfo } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_PATH =
  'COMPANY_LINKS.COMPANY_LINK_CARD.COMPANY_LINK_ACTIONS.DELETE_FREELANCER_CONFIRM_MODAL';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE';

type UseDeleteFreelancerReturnType = {
  handleDeleteFreelancer: (personId: string) => void;
};

export const useDeleteFreelancer = (): UseDeleteFreelancerReturnType => {
  const { t } = useTranslation('personDetailsGeneral');

  const { showError, showSuccess } = useNotification();

  const { mutate: mutateDelete } = useUpdatePersonPrivateInfo();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const onConfirm = (personId: string): void => {
    mutateDelete(
      {
        id: personId,
        data: { freelancer: null },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  const handleDeleteFreelancer = (personId: string): void => {
    modals.openConfirmModal({
      title: t(`${TRANS_PATH}.TITLE`),
      labels: {
        confirm: t(`${TRANS_PATH}.CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON', { ns: 'common' }),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: () => onConfirm(personId),
    });
  };

  return { handleDeleteFreelancer };
};
